import { useContext } from "react";
import { SettingsContext } from "../../providers/settings";
import { Drawer, Box, Hidden } from "@gti-controls-v2/web-core";
import Search from "./form-search";
import TitleSearch from "./title-header";
import LogoHeader from "./logo-header";
import homePageStyles from "../../common/styles/HomePage";

const SidebarSearch = () => {
    const { isMenuOpen, toggleMenu } = useContext(SettingsContext);
    const styles = homePageStyles;

    return (
        <div>
            <Hidden mdUp implementation="css">
                <div style={styles.sidebarContainerTemporal} id="box-container-sidebar-temporal">
                    <Drawer
                        id="drawer-container"
                        variant="temporary" 
                        anchor="left"
                        sx={styles.drawer}
                        open={isMenuOpen}
                        onClose={() => toggleMenu() }
                    >   
                        <LogoHeader />

                        <Box sx={styles.menuItems}>
                            <TitleSearch />
                            <Search />
                        </Box>
                    </Drawer>
                </div>
            </Hidden>
            <Hidden mdDown implementation="css">
                <div style={styles.sidebarContainer} id="box-container-sidebar">
                    <Drawer
                        id="drawer-container"
                        variant="permanent" 
                        anchor="left"
                        sx={styles.drawer}
                    >   
                        <LogoHeader />

                        <Box sx={styles.menuItems}>
                            <TitleSearch />
                            <Search />
                        </Box>
                    </Drawer>
                </div>
            </Hidden>
        </div>
    );
};

export default SidebarSearch;